<template>
    <div class="content">
        <headers :title='titles'></headers>
        <div v-if="!firstLoad">
            <div v-if="Object.keys(book).length==0">
                <div class="box">
                    <p class="p1"></p>
                    <p class="p2">您暂未设置<em>教辅</em></p>
                    <p class="p3">请设置一本<em>教辅</em>吧，设置过后才能查看讲解</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">设置教辅</a>
                </div>
            </div>
            <div v-else>
                <div class="title">
                    <div>
                        <p></p>
                        <p>{{book.name}}</p>
                        <p @click="setbook">更换<em>教辅</em></p>
                        <p></p>
                    </div>
                </div>
                <div class="main"
                     v-if="list.length >0">
                    <div class="main_box"
                         v-for="(i,index) in list">
                        <div class="main_title"
                             @click="open(i,index)">
                            <p><i></i></p>
                            <p>{{index+1}}.{{i.name}}</p>
                            <p :class="i.choise ? 'list_active' : 'list_noactive'"></p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <noResouse></noResouse>
                </div>
            </div>
        </div>
        <div v-else>
            <loading></loading>
        </div>
        <div class="foot"
             v-if="Object.keys(book).length!=0 && list.length">
            <div class="bottom_btn">
                <a :class="{'btn_a':next_btn}"
                   @click='next'>下一步</a>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { mapState } from 'vuex';
import loading from 'COMPONENTS/base/tealoading.vue'
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'
export default {
    data () {
        return {
            sid: this.$route.params.sid,
            // book_type: this.$route.query.bookType,
            hasbook: false,
            firstLoad: true,
            list: [],
            book: [],
            titles: '同步习题',
            // qid:[]
            catalogId: [],//章节id
            next_btn: false,
        }
    },
    components: {
        loading,
        noResouse,
        headers
    },
    computed: {

    },
    // watch: {
    // },
    async created () {
        let _sendok = localStorage.getItem('sendok');
        // //console.log(_sendok)
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
        } else {
            let o = {
                sid: this.sid,
                book_type: 1,
                code: '006'
            }
            await this.$http.post(API_URL_TASK_API + '/public/book/user_book', o).then(resp => {
                let res = resp.data;
                if (res.response === 'ok') {
                    this.$store.state.book = res.data;
                    this.book = res.data
                }
            })
            if (Object.keys(this.book).length != 0) {
                await this.getlist();
            } else {
                this.firstLoad = false
            }
        }
    },
    methods: {
        setbook () {
            this.$router.push('/setBook/' + this.sid + '/2/6')
        },
        getlist () {
            //console.log(this.book)
            if (Object.keys(this.book).length != 0) {
                this.$http.post(API_URL_TASK_API + '/english/send/catalog/sub', {
                    sid: this.sid,      //写死 需要更换
                    book_id: this.book.id
                }).then(resp => {
                    let res = resp.data;
                    this.firstLoad = false
                    if (res.response === 'ok') {
                        this.list = res.data;
                    }
                })
            } else {
                this.firstLoad = false
            }
        },
        open (i, ind) {
            i.choise = !i.choise;
            this.list.splice(ind, 1, i)
            if (i.choise) {
                this.catalogId.push(i.id);
            } else {
                let _num = this.catalogId.findIndex(item => item === i.id);
                this.catalogId.splice(_num, 1)
            }
            if (this.catalogId.length) {
                this.next_btn = true;
            } else {
                this.next_btn = false;
            }
        },
        next () {
            if (this.next_btn) {
                this.$store.commit('setTaskId', this.catalogId);
                this.$router.push('/english/test/screen/' + this.sid);
            }
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.set-book {
    display: block;
    margin: 40px / $ppr auto 0 auto;
    width: 360px / $ppr;
    height: 82px / $ppr;
    line-height: 82px / $ppr;
    font-size: 30px / $ppr;
    color: #fff;
    background: #5e89ef;
    border-radius: 41px / $ppr;
    text-align: center;
}
.content {
    width: 100%;
    height: auto;
    padding-bottom: 2.8rem;
    .title {
        width: 100%;
        height: 96px / $ppr;
        margin-bottom: 24px / $ppr;
        background: #fff;
        div {
            width: 673px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                line-height: 96px / $ppr;
                text-align: left;
            }
            p:nth-child(1) {
                width: 34px / $ppr;
                height: 34px / $ppr;
                background: url("img/icon_setbook.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
                float: left;
                margin: 31px / $ppr 24px / $ppr 0 0;
            }
            p:nth-child(2) {
                width: 462px / $ppr;
                float: left;
                font-size: 30px / $ppr;
                color: #333;
                @include ellipsis;
            }
            p:nth-child(3) {
                width: 139px / $ppr;
                color: #5e89ef;
                font-size: 30px / $ppr;
                float: left;
            }
            p:nth-child(4) {
                width: 14px / $ppr;
                height: 26px / $ppr;
                float: right;
                margin-top: 34px / $ppr;
                background: url("./img/enter.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
            }
        }
    }
    .main {
        width: 100%;
        height: auto;
        background: #fff;
        .main_box {
            width: 100%;
            height: auto;
            .main_title {
                width: 100%;
                height: 96px / $ppr;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p:nth-child(1) {
                    width: 80px / $ppr;
                    height: 96px / $ppr;
                    float: left;
                    i {
                        display: block;
                        width: 34px / $ppr;
                        height: 32px / $ppr;
                        background: url("img/icon_book.png") no-repeat;
                        -webkit-background-size: 100% 100%;
                        background-size: 100% 100%;
                        margin: 32px / $ppr 22px / $ppr 0 24px / $ppr;
                    }
                }
                p:nth-child(2) {
                    width: 556px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    float: left;
                    text-align: left;
                    @include ellipsis;
                }
                .list_active {
                    width: 40px / $ppr;
                    height: 40px / $ppr;
                    background: url("img/icon_select.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 28px / $ppr 24px / $ppr 0 0;
                }
                .list_noactive {
                    width: 40px / $ppr;
                    height: 40px / $ppr;
                    background: url("img/icon_unchecked.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 28px / $ppr 24px / $ppr 0 0;
                }
            }
            .main_con {
                width: 100%;
                height: 96px / $ppr;
                background: #f0f0f0;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p {
                    float: left;
                    box-sizing: border-box;
                }
                p:nth-child(1) {
                    width: 450px / $ppr;
                    margin-left: 106px / $ppr;
                    line-height: 96px / $ppr;
                    color: #333;
                    font-size: 30px / $ppr;
                    text-align: left;
                    @include ellipsis;
                }
                p:nth-child(2) {
                    width: 80px / $ppr;
                    height: 100%;
                    text-align: center;
                    color: #5e89ef;
                    font-size: 28px / $ppr;
                    position: relative;
                    left: 80px / $ppr;
                    img {
                        width: 45px / $ppr;
                        height: 45px / $ppr;
                        position: relative;
                        top: 25px / $ppr;
                        // left:5px/$ppr;
                    }
                }
            }
            .english_title {
                p:nth-child(2) {
                    width: 269px / $ppr;
                    @include ellipsis;
                }
                p:nth-child(3) {
                    width: 136px / $ppr;
                    line-height: 96px / $ppr;
                    text-align: center;
                    color: #5e89ef;
                    font-size: 28px / $ppr;
                    float: left;
                }
                p:nth-child(4) {
                    width: 184px / $ppr;
                    height: 54px / $ppr;
                    border: 1px / $ppr solid #5e89ef;
                    border-radius: 30px / $ppr;
                    margin-top: 20px / $ppr;
                    line-height: 54px / $ppr;
                    text-align: center;
                    font-size: 24px / $ppr;
                    color: #5e89ef;
                    float: left;
                }
            }
        }
    }
}

.box {
    //无教材
    width: 100%;
    height: auto;
    margin-top: 325px / $ppr;
    p {
        display: block;
    }
    .p1 {
        width: 136px / $ppr;
        height: 112px / $ppr;
        background: url("img/icon_nobook.png") no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .p2 {
        width: 100%;
        text-align: center;
        color: #333;
        font-size: 36px / $ppr;
        line-height: 36px / $ppr;
        margin: 40px / $ppr 0 16px / $ppr 0;
    }
    .p3 {
        width: 100%;
        text-align: center;
        color: #999;
        font-size: 24px / $ppr;
        line-height: 24px / $ppr;
        margin-bottom: 40px / $ppr;
    }
}

.foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    .bottom_btn {
        a {
            display: inline-block;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            width: 100%;
            color: #999999;
            background-color: $line;
            text-align: center;
            font-size: $lg;
            //font-weight: bold;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
    .bottom_btn2 {
        a {
            display: inline-block;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            width: 100%;
            color: $c-header;
            background-color: $c-theme;
            text-align: center;
            font-size: $lg;
        }
    }
}
</style>
